export default __webpack_public_path__ + "static/accountabilityandactionableinsights-4430db4771bac1757b8f9b7151c83c47.svg";